import { CircleCheck, Gauge } from "lucide-react";
import { band } from "@/components/ResultScore";
import { useAtsHistory, usePassMin } from "@/lib/atsScores";
import { ScoreBurst } from "@/components/ScoreBurst";
import { cn } from "@/lib/utils";

export const AtsBadge = ({ jobId }) => {
  const h = useAtsHistory(jobId);
  const min = usePassMin();
  if (!h.length) return null;
  const s = h[h.length - 1].score;
  const b = band(s, min);
  return (
    <>
      <ScoreBurst jobId={jobId}><span className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-mono text-[10px] font-bold", b.bg, b.text)} title={`Last ATS pass rate: ${s}% (${b.label})`} data-testid={`ats-badge-${jobId}`}>
        <Gauge className="h-3 w-3" />ATS {s}%
      </span></ScoreBurst>
      {s >= min && (
        <span className="inline-flex items-center gap-1 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-bold text-emerald-400" title={`Scored at or above your ${min}% pass score`} data-testid={`ready-badge-${jobId}`}>
          <CircleCheck className="h-3 w-3" />Ready to apply
        </span>
      )}
    </>
  );
};
